<div class="producerCodes">
  <mat-grid-list cols="5" rowHeight="3rem">
    <mat-grid-tile class="m-l-78">
      <span
        cg-mat-btn-type="link"
        data-test-id="modalClose"
        aria-label="close"
        [mat-dialog-close]="true"
        class="dialog-close-wrapper close-dialog"
        colspan="5"
      >
        <strong>Close</strong>
        <mat-icon
          aria-hidden="true"
          [mat-dialog-close]="true"
          class="dialog-close-icon"
        ></mat-icon>
      </span>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list id="modalHeading" cols="5" rowHeight="3rem">
    <mat-grid-tile
      data-test-id="modalTitle"
      aria-labelledby="alertTitle"
      colspan="5"
      class="dialog-title"
    >
      <h5
        *ngIf="!isSingleProducerCode && !isCheckExpiredPcode"
        class="alertTitle request-access-to-st"
        id="ModalStmtTitle"
        data-test-id="PopUp-Modal-Hdr"
      >
        {{ 'broker.tools.selectProducer' | translate }}
      </h5>
      <h5
        *ngIf="!isSingleProducerCode && isCheckExpiredPcode"
        class="alertTitle request-access-to-st"
        id="ModalStmtTitle"
        data-test-id="PopUp-Modal-Hdr"
      >
        {{ 'broker.tools.selectProducer' | translate }}
      </h5>
      <h5
        data-test-id="contract-validation-error"
        *ngIf="isSingleProducerCode && isCheckExpiredPcode"
        class="request-access-to-st contracterror"
        id="ModalStmtTitle"
      >
        Contract Validation Error!
      </h5>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-dialog-content class="req-access-dialog p-l-50">
    <div class="rbtn-group" *ngIf="!isSingleProducerCode">
      <div class="flex-container" *ngFor="let option of roles">
        <div class="flex-child2">
          <mat-radio-button
            [attr.data-test-id]="'producer-codes-' + option.producerCode"
            [value]="option.producerCode"
            [checked]="option.producerCode == selectedProducerCode"
            class="example-radio-button"
            (change)="changeProducerCode(option.producerCode)"
          >
            {{ option.producerCode }}
          </mat-radio-button>
        </div>
        <div class="flex-child1 error-text-icon">
          <cigna-icon
            type="alert-triangle"
            *ngIf="
              !selectedContractValid &&
              option.producerCode == selectedProducerCode &&
              isCheckExpiredPcode
            "
          ></cigna-icon>
        </div>
        <div class="flex-child">
          <p
            data-test-id="pc-error-text"
            class="error-text"
            *ngIf="
              !selectedContractValid &&
              option.producerCode == selectedProducerCode &&
              isCheckExpiredPcode
            "
          >
            You cannot be validated as contracted to sell Cigna IFP business
            under this code. If you think this is in error, please contact the
            following number for support: 1-877-244-6215.
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="isSingleProducerCode && isCheckExpiredPcode"
      data-test-id="pc-error-text"
      class="ifp-error-text"
    >
      <span
        >You cannot be validated as contracted to sell Cigna IFP business under
        this code. If you think this is in error, please contact the following
        number for support: 1-877-244-6215.</span
      >
    </div>
    <div>
      <br />
      <div mat-dialog-actions>
        <button
          [disabled]="!selectedRoleId"
          data-test-id="btnSetModalContinue"
          mat-raised-button
          cg-mat-btn-type="primary"
          class="btn-small"
          type="sub"
          (click)="goToURL()"
        >
          {{ 'broker.compensation.requestaccess.continue' | translate }}
        </button>
        <button
          data-test-id="btnSetModalCancel"
          mat-raised-button
          mat-dialog-close
          cg-mat-btn-type="secondary"
          class="btn-small"
        >
          {{ 'broker.compensation.requestaccess.close' | translate }}
        </button>
      </div>
      <br />
    </div>
  </mat-dialog-content>
</div>
